module.exports = __webpack_public_path__ + "media/sà-wàt-dee kráp.e3431c06.mp3";